import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const deleteSkillMapLines = api(async function deleteSkillMapLines({ ids }) {
    return mutate(
        gql`
            mutation DeleteSkillMapLines($ids: [String!]!) {
                deleteSkillMapLines(ids: $ids)
            }
        `,
        { ids },
        { returns: "deleteSkillMapLines" }
    )
})
